/* Shared cell formatters. */

/*
 * Two decimal places, matching the old `str_round_2` Angular filter.
 * Expected-goals figures are computed sums, so they arrive with float
 * artefacts (0.9770000000000002) that should not reach a table cell.
 * Trailing zeroes are kept so a column of values aligns on the decimal.
 */
export function round2(value) {
	if (value === null || value === undefined || value === '') return '';
	const n = Number(value);
	return Number.isFinite(n) ? n.toFixed(2) : value;
}

/*
 * How long ago, in words.
 *
 * Relative up to a week, because "3 hours ago" is what you want to know
 * about something you just changed; absolute beyond that, because "63 days
 * ago" is not how anyone thinks about a date.
 *
 * The API marks its timestamps UTC, so Date parses them to the right
 * instant and the browser renders in the reader's own zone.
 */
export function timeAgo(iso) {
	if (!iso) return null;
	const then = new Date(iso);
	if (Number.isNaN(then.getTime())) return null;

	const seconds = Math.round((Date.now() - then.getTime()) / 1000);
	if (seconds < 60) return 'just now';

	const minutes = Math.round(seconds / 60);
	if (minutes < 60) return `${minutes} minute${minutes === 1 ? '' : 's'} ago`;

	const hours = Math.round(minutes / 60);
	if (hours < 24) return `${hours} hour${hours === 1 ? '' : 's'} ago`;

	const days = Math.round(hours / 24);
	if (days === 1) return 'yesterday';
	if (days < 7) return `${days} days ago`;

	return then.toLocaleDateString(undefined, {
		day: 'numeric',
		month: 'short',
		year: then.getFullYear() === new Date().getFullYear() ? undefined : 'numeric',
	});
}
